module.exports = __webpack_public_path__ + "media/images/en-b4909cfe.svg";